<template>
<div class="chapter">
<div class="inner_page">
<p class="centerf">Praise for #1 internationally bestselling author</p>
<p class="centerfa">Santa Montefiore</p>
<p class="centerf2">“Santa Montefiore is a wonder.”</p>
<p class="centerf1">—Adriana Trigiani</p>
<p class="centerf2">“Engaging and charming.”</p>
<p class="centerf1">—Penny Vincenzi</p>
<p class="centerf2">“Santa Montefiore is a superb storyteller. One laughs as much as one cries.”</p>
<p class="centerf1">—Plum Sykes</p>
<p class="centerf2">“Epic in scope and emotion . . . surprising, moving, and skilful.”</p>
<p class="centerf1">—Elizabeth Buchan</p>
<p class="centerf2">“Montefiore’s writing is enchanting.”</p>
<p class="centerf1">—<span class="txit">Hollywood Today</span></p>
<p class="centerf2">“Like her countrywomen Barbara Taylor Bradford and Penny Vincenzi, Montefiore excels at juxtaposing the opulent with the ordinary in delicately woven tales that seamlessly traverse borders and span decades.”</p>
<p class="centerf1">—<span class="txit">Booklist</span></p>
<p class="centerf2">“Santa Montefiore is the new Rosemunde Pilcher.”</p>
<p class="centerf1">—<span class="txit">Daily Mail</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praise.vue?3d84944c